import { FormCentralizer } from '@/components';
import { useCreateOrganization } from '@/features/tenant-manager/organization/_hooks/organization';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { OrganizationForm } from '../_components/OrganizationForm';

export const CreateOrganizationPage: FC = () => {
  const navigate = useNavigate();
  const { openMessage } = useMessage();
  const { t } = useTranslation();
  const { mutateAsync: createOrganization } = useCreateOrganization();

  return (
    <FormCentralizer>
      <OrganizationForm
        onSubmit={async (values) => {
          try {
            const res = await createOrganization({
              ...values,
            });

            await Promise.all([
              openMessage('success', t('message-save-completed')),
              (async () => {
                navigate(`/tenant-manager/organizations/${res.id}`, {
                  replace: true,
                });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-save-failed'));
          }
        }}
      />
    </FormCentralizer>
  );
};
